import { Client } from "../../clients/client";

import { Item } from "./models/Item";
import { Shop } from "../shop/models/Shop";

export class ItemUseCase {
  constructor(private client: Client) {}

  public async checkItem(shop: Shop, sku: string): Promise<Item> {
    return this.client.items.postSearch({
      shopId: shop.id,
      myCloudSku: sku
    });
  }
}
